/* eslint-disable */
// import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const SubdomainKey = 'Subdomain-Client' //subdomain klien e.q: demo --> demo.inofarmapos.com
const MultiAccountKey = [] //key multi account
const ApplicationType = 'ApplicationType'


const AuthorizationUsername = 'inolabs-microservices'
const AuthorizationPassword = 'DSrXT9LTSCZShS5M64pZjp5Caq6ZpCuh'
const Authorization = 'Basic ' + btoa(AuthorizationUsername + ':' + AuthorizationPassword)

export function setMultiAccount(arrValue) {
  removeMultiAccount()
  var jsonValue=JSON.stringify(arrValue)
  // console.log("jsonValue",jsonValue)
  return localStorage.setItem(MultiAccountKey, jsonValue)
}

export function getMultiAccount() {
  
  var getValue=localStorage.getItem(MultiAccountKey)
  var parseValue=JSON.parse(getValue)
  return parseValue
}

export function removeMultiAccount() {
  return localStorage.removeItem(MultiAccountKey)
}

export function setSubdomain(subdomain) {
  return localStorage.setItem(SubdomainKey, subdomain)
  // return Cookies.set(SubdomainKey, subdomain)
}

export function getSubdomain() {
  return localStorage.getItem(SubdomainKey)
  // return Cookies.get(SubdomainKey)
}

export function removeSubdomain() {
  // return Cookies.remove(TokenKey)
  return localStorage.removeItem(SubdomainKey)
}

export function getToken() {
  return localStorage.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function getAuthorization() {
  return Authorization
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return localStorage.removeItem(TokenKey)
}

export function setApplicationType(value) {
  return localStorage.setItem(ApplicationType, value)
}

export function getApplicationType() {
  return localStorage.getItem(ApplicationType)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js